import React from 'react';
import './iconButton.css'

interface IconButtonProps {
  icon: any;
  label?: string;
  onClick?: () => void;
  className?: string; 
  disabled?: boolean;
}

const IconButton: React.FC<IconButtonProps> = ({ icon, label, onClick, className , disabled}) => {
  return (
    <div className={`flex flex-col items-center gap-2 ${className || ''}`}>
      <button disabled={disabled} className={`btn-icon ${disabled ? 'btn-icon-disabled' : ''}`} onClick={onClick}>
        {icon}
      </button>
      {label && <span className="text-sm font-semibold">{label}</span>}
    </div>
  );
};

export default IconButton;